const getSiteSchema = (templateOptions, siteModels, isNewSite) => {
  const hasSiteModels = Array.isArray(siteModels) && siteModels.length > 0;

  const schema = {
    type: 'object',
    required: ['name', 'customer', 'location'],
    properties: {
      name: {
        type: 'string',
        title: 'Name',
      },
      customer: {
        type: 'string',
        title: 'Customer',
      },
      isTemplate: {
        type: 'boolean',
        default: false,
        title: 'Set as template site',
        description: 'Should this site be used as a template for other sites?',
      },
      ...(isNewSite
        ? {}
        : {
            siteImage: {
              type: 'object',
              title: 'Site Image',
              properties: {
                siteImagePreview: {
                  type: 'string',
                  title: 'Site Image Preview',
                },
                linkSiteImage: {
                  type: ['string', 'null'],
                  title: 'Site Image Link',
                  description: 'SITE_IMAGE_TOOLTIP_NAVLINK',
                  position: 'right',
                  tooltipFullWidth: true,
                  showTooltip: true,
                  isInteractive: true,
                  ...(hasSiteModels
                    ? {
                        default: null,
                        placeholder: 'Select a model thumbnail to display as site image.',
                        oneOf: [
                          {
                            enum: [null],
                            title: 'No image',
                          },
                          ...siteModels.map((model) => ({
                            enum: [model.id],
                            title: model.name,
                          })),
                        ],
                      }
                    : {
                        default: null,
                        readOnly: true,
                        placeholder: 'No model thumbnails available, please add a model.',
                      }),
                },
              },
            },
          }),
      location: {
        type: 'object',
        title: 'Location',
        required: ['lat', 'lng', 'city', 'country'],
        properties: {
          city: {
            type: 'string',
            title: 'City',
          },
          country: {
            type: 'string',
            title: 'Country',
          },
          lat: {
            type: 'number',
            title: 'Latitude',
            minimum: -90,
            maximum: 90,
          },
          lng: {
            type: 'number',
            title: 'Longitude',
            minimum: -180,
            maximum: 180,
          },
        },
      },
      support: {
        type: 'object',
        title: 'Site support info',
        properties: {
          name: {
            type: 'string',
            title: 'Name of support contact',
          },
          email: {
            type: 'string',
            inputType: 'email',
            title: 'Support contact email',
          },
          phone: {
            type: 'string',
            title: 'Support phone number',
          },
        },
      },
    },
  };

  if (templateOptions) {
    schema.properties.template = {
      type: 'string',
      title: 'Template',
      default: 'default',
      anyOf: [
        {
          enum: ['default'],
          title: 'Default template',
        },
        ...templateOptions.map((template) => ({
          enum: [template.key],
          title: template.siteName,
        })),
      ],
    };
  }

  return schema;
};

const siteUISchema = {
  'ui:options': { orderable: false },
  siteImage: {
    siteImagePreview: {
      'ui:field': 'siteImagePreviewField',
    },
    linkSiteImage: {
      'ui:field': 'customUnitLabel',
    },
  },
};

export { getSiteSchema, siteUISchema };
